/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaInputDatePicker from 'DesignSystem/TysiaInput/TysiaInputDatePicker/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  closePopover,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/TasksList/Content/Content/DueDate/Content"
  
}) {
let taskDueDateValueData = fromData.useDataValue({ viewPath,
context: 'task',
path: 'due_date',
})
let aggregateData = fromAggregate.getValueOrDefault(taskDueDateValueData)
let onChange = fromHelpers.useOnChange({
  children,
  closePopover,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaInputDatePicker
  viewPath={`${viewPath}/TysiaInputDatePicker`}
 top={0}
 data="task.due_date"
 aggregate="/Data/aggregate.js getValueOrDefault"
 value={aggregateData}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}